export { default as default } from './Icona';
